import { CONST } from '../constant';

export default {
  CONTENT_TYPE_JPEG: 'image/jpeg',
  CONTENT_TYPE_PNG: 'image/png',

  downScaleCanvas(cv, scale) {
    if (!(scale < 1) || !(scale > 0)) throw 'scale must be a positive number <1 ';
    var ncv = document.createElement('canvas');
    var ctx = ncv.getContext('2d');

    ncv.width = cv.width * scale;
    ncv.height = cv.height * scale;
    ctx.scale(scale, scale);
    ctx.drawImage(cv, 0, 0);
    return ncv;
  },

  // scales the canvas by (float) scale < 1
  // returns a new canvas containing the scaled image.
  downScaleCanvasClear(cv, scale) {
    if (!(scale < 1) || !(scale > 0)) throw 'scale must be a positive number <1 ';
    var sqScale = scale * scale; // square scale = area of source pixel within target
    var sw = cv.width; // source image width
    var sh = cv.height; // source image height
    var tw = Math.floor(sw * scale); // target image width
    var th = Math.floor(sh * scale); // target image height
    var sx = 0,
      sy = 0,
      sIndex = 0; // source x,y, index within source array
    var tx = 0,
      ty = 0,
      yIndex = 0,
      tIndex = 0; // target x,y, x,y index within target array
    var tX = 0,
      tY = 0; // rounded tx, ty
    var w = 0,
      nw = 0,
      wx = 0,
      nwx = 0,
      wy = 0,
      nwy = 0; // weight / next weight x / y
    // weight is weight of current source point within target.
    // next weight is weight of current source point within next target's point.
    var crossX = false; // does scaled px cross its current px right border ?
    var crossY = false; // does scaled px cross its current px bottom border ?
    var sBuffer = cv.getContext('2d').getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
    var tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
    var sR = 0,
      sG = 0,
      sB = 0; // source's current point r,g,b
    /* untested !
        var sA = 0;  //source alpha  */

    for (sy = 0; sy < sh; sy++) {
      ty = sy * scale; // y src position within target
      tY = 0 | ty; // rounded : target pixel's y
      yIndex = 3 * tY * tw; // line index within target array
      crossY = tY != (0 | (ty + scale));
      if (crossY) {
        // if pixel is crossing botton target pixel
        wy = tY + 1 - ty; // weight of point within target pixel
        nwy = ty + scale - tY - 1; // ... within y+1 target pixel
      }
      for (sx = 0; sx < sw; sx++, sIndex += 4) {
        tx = sx * scale; // x src position within target
        tX = 0 | tx; // rounded : target pixel's x
        tIndex = yIndex + tX * 3; // target pixel index within target array
        crossX = tX != (0 | (tx + scale));
        if (crossX) {
          // if pixel is crossing target pixel's right
          wx = tX + 1 - tx; // weight of point within target pixel
          nwx = tx + scale - tX - 1; // ... within x+1 target pixel
        }
        sR = sBuffer[sIndex]; // retrieving r,g,b for curr src px.
        sG = sBuffer[sIndex + 1];
        sB = sBuffer[sIndex + 2];

        /* !! untested : handling alpha !!
                   sA = sBuffer[sIndex + 3];
                   if (!sA) continue;
                   if (sA != 0xFF) {
                       sR = (sR * sA) >> 8;  // or use /256 instead ??
                       sG = (sG * sA) >> 8;
                       sB = (sB * sA) >> 8;
                   }
                */
        if (!crossX && !crossY) {
          // pixel does not cross
          // just add components weighted by squared scale.
          tBuffer[tIndex] += sR * sqScale;
          tBuffer[tIndex + 1] += sG * sqScale;
          tBuffer[tIndex + 2] += sB * sqScale;
        } else if (crossX && !crossY) {
          // cross on X only
          w = wx * scale;
          // add weighted component for current px
          tBuffer[tIndex] += sR * w;
          tBuffer[tIndex + 1] += sG * w;
          tBuffer[tIndex + 2] += sB * w;
          // add weighted component for next (tX+1) px
          nw = nwx * scale;
          tBuffer[tIndex + 3] += sR * nw;
          tBuffer[tIndex + 4] += sG * nw;
          tBuffer[tIndex + 5] += sB * nw;
        } else if (crossY && !crossX) {
          // cross on Y only
          w = wy * scale;
          // add weighted component for current px
          tBuffer[tIndex] += sR * w;
          tBuffer[tIndex + 1] += sG * w;
          tBuffer[tIndex + 2] += sB * w;
          // add weighted component for next (tY+1) px
          nw = nwy * scale;
          tBuffer[tIndex + 3 * tw] += sR * nw;
          tBuffer[tIndex + 3 * tw + 1] += sG * nw;
          tBuffer[tIndex + 3 * tw + 2] += sB * nw;
        } else {
          // crosses both x and y : four target points involved
          // add weighted component for current px
          w = wx * wy;
          tBuffer[tIndex] += sR * w;
          tBuffer[tIndex + 1] += sG * w;
          tBuffer[tIndex + 2] += sB * w;
          // for tX + 1; tY px
          nw = nwx * wy;
          tBuffer[tIndex + 3] += sR * nw;
          tBuffer[tIndex + 4] += sG * nw;
          tBuffer[tIndex + 5] += sB * nw;
          // for tX ; tY + 1 px
          nw = wx * nwy;
          tBuffer[tIndex + 3 * tw] += sR * nw;
          tBuffer[tIndex + 3 * tw + 1] += sG * nw;
          tBuffer[tIndex + 3 * tw + 2] += sB * nw;
          // for tX + 1 ; tY +1 px
          nw = nwx * nwy;
          tBuffer[tIndex + 3 * tw + 3] += sR * nw;
          tBuffer[tIndex + 3 * tw + 4] += sG * nw;
          tBuffer[tIndex + 3 * tw + 5] += sB * nw;
        }
      } // end for sx
    } // end for sy

    // create result canvas
    var resCV = document.createElement('canvas');
    resCV.width = tw;
    resCV.height = th;
    var resCtx = resCV.getContext('2d');
    var imgRes = resCtx.getImageData(0, 0, tw, th);
    var tByteBuffer = imgRes.data;
    // convert float32 array into a UInt8Clamped Array
    var pxIndex = 0; //
    for (sIndex = 0, tIndex = 0; pxIndex < tw * th; sIndex += 3, tIndex += 4, pxIndex++) {
      tByteBuffer[tIndex] = Math.ceil(tBuffer[sIndex]);
      tByteBuffer[tIndex + 1] = Math.ceil(tBuffer[sIndex + 1]);
      tByteBuffer[tIndex + 2] = Math.ceil(tBuffer[sIndex + 2]);
      tByteBuffer[tIndex + 3] = 255;
    }

    // writing result to canvas.
    resCtx.putImageData(imgRes, 0, 0);
    return resCV;
  },

  // scales the image by (float) scale < 1
  // returns a canvas containing the scaled image.
  downScaleImage(img, scale) {
    var cv = document.createElement('canvas');
    cv.width = img.width;
    cv.height = img.height;
    var ctx = cv.getContext('2d');
    ctx.drawImage(img, 0, 0);
    return this.downScaleCanvas(cv, scale);
  },

  /**
   * return new canvas
   */
  crop(fromCv, cropWidth, cropHeight) {
    var wRate = cropWidth / fromCv.width;
    var hRate = cropHeight / fromCv.height;
    if (wRate < 1 && hRate < 1) {
      return this.copyCv(this.downScaleImage(fromCv, wRate > hRate ? wRate : hRate), cropWidth, cropHeight);
    }
    if (wRate >= 1 && hRate < 1) {
      return this.copyCv(fromCv, cropWidth, fromCv.height);
    }
    if (wRate < 1 && hRate >= 1) {
      return this.copyCv(fromCv, fromCv.width, cropHeight);
    }
    return fromCv;
  },

  copyCv(fromCv, toWidth, toHeight) {
    var cv = document.createElement('canvas');
    cv.width = toWidth;
    cv.height = toHeight;
    cv.getContext('2d').drawImage(fromCv, -(fromCv.width - toWidth) / 2, -(fromCv.height - toHeight) / 2);
    return cv;
  },

  dataURLToCanvas(dataURI, orientation, cb, onError) {
    var _this = this;
    var img = new Image();
    img.onload = function() {
      cb(_this.imgToCanvas(img, orientation));
    };
    img.onabort = function() {
      cb('abort');
    };
    img.onerror = function() {
      cb('error');
    };
    img.src = dataURI;
  },

  imgToCanvas(image, orientation) {
    var wScale = CONST.img_size.img / image.width;
    var hScale = CONST.img_size.img / image.height;

    if (wScale < 1 || hScale < 1) {
      var scale = wScale < hScale ? wScale : hScale;
      var tmpcv = document.createElement('canvas');
      var tmpctx = tmpcv.getContext('2d');
      tmpcv.width = image.width * scale;
      tmpcv.height = image.height * scale;
      tmpctx.scale(scale, scale);
      tmpctx.drawImage(image, 0, 0);
      if (!orientation || orientation < 2 || orientation > 8) {
        return tmpcv;
      }
      image = tmpcv;
    }

    var cv = document.createElement('canvas');
    var ctx = cv.getContext('2d');

    if (!orientation || orientation < 2 || orientation > 8) {
      cv.width = image.width;
      cv.height = image.height;
      ctx.drawImage(image, 0, 0);
      return cv;
    }

    var image_aspect, cv_width, cv_height, draw_width, draw_height;

    image_aspect =
      orientation == 5 || orientation == 6 || orientation == 7 || orientation == 8
        ? image.width / image.height
        : image.height / image.width;

    cv_width = image.width;
    cv_height = Math.floor(cv_width * image_aspect);

    cv.width = cv_width;
    cv.height = cv_height;

    draw_width = cv_width;
    draw_height = cv_height;

    switch (orientation) {
      case 2:
        ctx.transform(-1, 0, 0, 1, cv_width, 0);
        break;
      case 3:
        ctx.transform(-1, 0, 0, -1, cv_width, cv_height);
        break;
      case 4:
        ctx.transform(1, 0, 0, -1, 0, cv_height);
        break;
      case 5:
        ctx.transform(-1, 0, 0, 1, 0, 0);
        ctx.rotate((90 * Math.PI) / 180);
        draw_width = cv_height;
        draw_height = cv_width;
        break;
      case 6:
        ctx.transform(1, 0, 0, 1, cv_width, 0);
        ctx.rotate((90 * Math.PI) / 180);
        draw_width = cv_height;
        draw_height = cv_width;
        break;
      case 7:
        ctx.transform(-1, 0, 0, 1, cv_width, cv_height);
        ctx.rotate((-90 * Math.PI) / 180);
        draw_width = cv_height;
        draw_height = cv_width;
        break;
      case 8:
        ctx.transform(1, 0, 0, 1, 0, cv_height);
        ctx.rotate((-90 * Math.PI) / 180);
        draw_width = cv_height;
        draw_height = cv_width;
        break;
      default:
        break;
    }

    ctx.drawImage(image, 0, 0, draw_width, draw_height);

    return cv;
  },

  canvasToImg(canvas, imgElement, mime, quality) {
    imgElement.width = canvas.width;
    imgElement.height = canvas.height;
    imgElement.src = canvas.toDataURL(mime, quality);
  },

  getExifs(exif, tags) {
    var json = {};
    for (var tag in tags) {
      json[tags[tag]] = EXIF.getTag(exif, tags[tag]);
    }
    return json;
  },

  getExifData(file, callback) {
    EXIF.getData(file, function() {
      var tags = [
        'DateTimeOriginal',
        'Orientation',
        'GPSDateStamp',
        'GPSTimeStamp',
        'TimeZoneOffset',
        'GPSLatitudeRef',
        'GPSLatitude',
        'GPSLongitudeRef',
        'GPSLongitude',
        'GPSAltitude',
        'Content Create Date',
        'Creation Date',
        'Rotation',
      ];
      var json = {};
      for (var tag in tags) {
        json[tags[tag]] = EXIF.getTag(this, tags[tag]);
      }
      callback(json);
    });
  },
  getExifDataWithTimeout(file, success, failure, millis) {
    if (!millis) millis = 1000;
    var timeout = false;
    var done = false;
    setTimeout(function() {
      if (done) return;
      timeout = true;
      console.warn('getting exif timeouted!');
      failure();
    }, millis);
    this.getExifData(file, function(json) {
      done = true;
      if (timeout) return;
      success(json);
    });
  },

  dataUrlToBlob(dataUrl, type) {
    var bin = atob(dataUrl.split(',')[1]);
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    return new Blob([buffer.buffer], { type: type });
  },

  arrayBufferToDataUrl(ab, contentType) {
    var bytes = new Uint8Array(ab);
    var binaryData = '';
    for (var i = 0, len = bytes.byteLength; i < len; i++) {
      binaryData += String.fromCharCode(bytes[i]);
    }
    return 'data:' + contentType + ';base64,' + window.btoa(binaryData);
  },

  CLEAR_MAT_DATA: (function(wh, mime) {
    console.log('create clear mat');
    var cv = document.createElement('canvas');
    cv.grobalAlpha = 0;
    cv.width = wh;
    cv.height = wh;
    var ctx = cv.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.rect(0, 0, wh, wh);
    ctx.fill();
    return cv.toDataURL(mime, 1);
  })(1, 'image/gif'),
};
